import { useState, useMemo } from "react";

export default function OfferLetter() {
  const [tab, setTab] = useState("company");
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({
    companyName: "Gurukrupa Placement & Education Solutions Pvt. Ltd.",
    companyShort: "GPES",
    companyTagline: "Empowering Careers. Building Futures.",
    cin: "U80100MH2020PTC123456",
    regAddress: "Office No. 12, Sector 7, Kharghar, Navi Mumbai – 410210",
    corpAddress: "Mumbai, Maharashtra – 400001",
    companyEmail: "hr@gurukrupaeducation.com",
    companyPhone: "+91 22 4567 8900",
    companyWebsite: "www.gurukrupaeducation.com",
    sigName: "Priya Sharma",
    sigDesignation: "Senior Manager – Human Resources",
    employeeName: "",
    address: "",
    email: "",
    phone: "",
    position: "",
    department: "",
    grade: "",
    employeeId: "",
    manager: "",
    employmentType: "Full Time",
    joiningDate: "",
    duration: "Permanent",
    probation: "6 months",
    location: "Mumbai",
    workingHours: "9:00 AM – 6:00 PM (Monday to Saturday)",
    weeklyOff: "Sunday",
    noticePeriod: "30 days",
    leavePolicy: "18 days (Earned Leave) + 10 days (Casual Leave) per annum",
    internshipType: "",
    stipend: "",
    salary: "",
    hra: "",
    conveyance: "",
    medicalAllowance: "",
    bonus: "",
    specialAllowance: "",
    workDescription: "",
    benefits: "Group health insurance, PF as per statutory norms, gratuity eligibility post 5 years, professional development reimbursement, and performance-linked increments.",
    documentsRequired: "Aadhaar Card, PAN Card, Passport-size photographs (3), all academic mark sheets and certificates, previous employment relieving letter (if applicable), cancelled cheque / bank account details.",
    additionalTerms: "This offer shall stand void if any information provided by you is found to be false or misleading. The company reserves the right to withdraw this offer at any time prior to joining.",
  });

  const set = (e) => setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const fmt = (v) => Number(v || 0).toLocaleString("en-IN");
  const fmtDate = (v) => v ? new Date(v).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" }) : "__________";
  const today = new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" });

  const totalCTC = useMemo(() =>
    [form.salary, form.hra, form.conveyance, form.medicalAllowance, form.bonus, form.specialAllowance]
      .reduce((a, v) => a + Number(v || 0), 0),
    [form.salary, form.hra, form.conveyance, form.medicalAllowance, form.bonus, form.specialAllowance]
  );

  const isIntern = form.employmentType === "Internship";
  const hasSalary = form.employmentType === "Full Time" || form.employmentType === "Contract";

  const printLetter = () => {
    const content = document.getElementById("the-letter").innerHTML;
    const w = window.open("", "_blank", "width=900,height=900");
    w.document.write(`<!DOCTYPE html><html><head>
      <title>${form.employeeName || "Candidate"} – Offer Letter – ${form.companyShort}</title>
      <link href="https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,400&family=Source+Sans+3:wght@300;400;500;600;700&display=swap" rel="stylesheet">
      <style>
        *{box-sizing:border-box;margin:0;padding:0}
        body{font-family:'Source Sans 3',sans-serif;font-size:13.5px;color:#111;background:#fff;padding:0}
        .letter{max-width:780px;margin:0 auto;padding:0}
        .lh-wrap{padding:28px 48px 0}
        .lh-top{display:flex;justify-content:space-between;align-items:flex-start;padding-bottom:16px}
        .logo-box{display:flex;align-items:center;gap:14px;margin-bottom:8px}
        .logo-sq{width:48px;height:48px;background:#003087;display:flex;align-items:center;justify-content:center;font-family:'EB Garamond',serif;font-size:22px;font-weight:700;color:#fff}
        .co-name-lh{font-family:'EB Garamond',serif;font-size:20px;font-weight:700;color:#003087;line-height:1.2}
        .co-tagline-lh{font-size:10.5px;color:#666;letter-spacing:0.06em}
        .lh-contact{font-size:11.5px;color:#444;line-height:1.9;margin-top:10px}
        .ref-block{text-align:right;font-size:12px;color:#444;line-height:1.9}
        .ref-no{font-size:13px;font-weight:700;color:#111;display:block;margin-bottom:2px}
        .rule-double{height:3px;background:#003087;margin:0 48px 2px}
        .rule-thin{height:1px;background:#003087;margin:0 48px 12px}
        .letter-body-inner{padding:24px 48px 40px}
        .cand-addr{margin-bottom:18px;font-size:13.5px;line-height:1.8;color:#111}
        .subject-block{margin-bottom:20px}
        .sub-label{font-size:13.5px;font-weight:700;color:#111;margin-bottom:3px}
        .sub-line{font-size:13.5px;font-weight:700;color:#111;text-decoration:underline;line-height:1.5}
        .dear-line{font-size:13.5px;margin-bottom:16px;margin-top:4px}
        .para{font-size:13.5px;line-height:1.85;color:#111;margin-bottom:14px}
        .info-tbl{width:100%;border-collapse:collapse;margin:16px 0 20px}
        .info-tbl td{padding:8px 12px;font-size:13px;border:1px solid #ccc;vertical-align:top}
        .info-tbl td.lbl{font-weight:600;background:#f2f5fb;width:38%;color:#003087}
        .sal-tbl{width:100%;border-collapse:collapse;margin:14px 0 6px}
        .sal-tbl th{background:#003087;color:#fff;padding:10px 14px;text-align:left;font-size:12.5px;font-weight:600}
        .sal-tbl th:last-child,.sal-tbl td:last-child{text-align:right}
        .sal-tbl td{border:1px solid #dde;padding:9px 14px;font-size:13px}
        .sal-tbl tr:nth-child(even) td{background:#f6f8fc}
        .sal-tbl tfoot td{background:#e4eaf5;font-weight:700;font-size:13.5px;border-top:2px solid #003087}
        .sal-note{font-size:11.5px;color:#666;margin-top:6px;font-style:italic}
        .clauses-title{font-size:12px;font-weight:700;color:#003087;margin:22px 0 12px;text-transform:uppercase;letter-spacing:0.06em}
        .clause-row{display:flex;gap:10px;margin-bottom:10px;font-size:13.5px;line-height:1.85;color:#111}
        .cn{font-weight:700;flex-shrink:0;min-width:24px;color:#003087}
        .sig-section{margin-top:44px;display:flex;justify-content:space-between}
        .sig-box{width:42%}
        .sig-line{border-top:1px solid #333;margin-bottom:9px}
        .sig-name{font-weight:700;font-size:13.5px}
        .sig-role{font-size:12.5px;color:#555;line-height:1.7}
        .ack-box{margin:28px 0 0;border:1px solid #bbb;padding:18px 20px;background:#fafafa}
        .ack-title{font-weight:700;font-size:13px;text-decoration:underline;margin-bottom:10px;color:#111}
        .ack-row{display:flex;justify-content:space-between;gap:32px;margin-top:18px}
        .ack-sig{flex:1}
        .ack-sig-line{border-top:1px solid #888;margin-bottom:7px}
        .ack-sig-lbl{font-size:12px;color:#555}
        .letter-footer-bar{border-top:1px solid #ccc;padding:12px 48px;font-size:11px;color:#777;line-height:1.75}
        .cin-line{font-weight:600;color:#555}
        @page{margin:14mm 12mm}
      </style>
    </head><body><div class="letter">${content}</div></body></html>`);
    w.document.close();
    setTimeout(() => { w.focus(); w.print(); }, 700);
  };

  const tabs = ["company", "employee", "employment", "compensation", "terms"];
  const tabLabel = { company: "Company", employee: "Employee", employment: "Job", compensation: "Pay", terms: "Terms" };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=EB+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,400&family=Source+Sans+3:wght@300;400;500;600;700&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        .app{min-height:100vh;background:#e8ecf2;font-family:'Source Sans 3',sans-serif;padding:24px 18px}
        .wrap{max-width:1620px;margin:0 auto;display:grid;grid-template-columns:380px 1fr;gap:22px;align-items:start}

        /* sidebar */
        .sidebar{background:#003087;border-radius:12px;padding:28px 24px;position:sticky;top:18px;
          max-height:calc(100vh - 36px);overflow-y:auto;overflow-x:hidden;
          box-shadow:0 20px 60px rgba(0,48,135,0.35);scrollbar-width:thin;scrollbar-color:rgba(255,255,255,0.2) transparent}
        .sidebar::-webkit-scrollbar{width:3px}
        .sidebar::-webkit-scrollbar-thumb{background:rgba(255,255,255,0.2)}
        .sb-brand{display:flex;align-items:center;gap:12px;margin-bottom:22px}
        .sb-logo{width:44px;height:44px;background:#fff;border-radius:6px;display:flex;align-items:center;
          justify-content:center;font-family:'EB Garamond',serif;font-size:20px;font-weight:700;color:#003087;flex-shrink:0}
        .sb-brand-name{font-family:'EB Garamond',serif;font-size:16px;font-weight:700;color:#fff;line-height:1.2}
        .sb-brand-sub{font-size:10px;color:rgba(255,255,255,0.45);letter-spacing:0.07em;text-transform:uppercase;margin-top:2px}
        .sb-title{font-family:'EB Garamond',serif;font-size:26px;font-weight:700;color:#fff;line-height:1.1;margin-bottom:5px}
        .sb-desc{font-size:12.5px;color:rgba(255,255,255,0.45);line-height:1.6;margin-bottom:22px}

        .tab-row{display:flex;gap:3px;background:rgba(255,255,255,0.07);border-radius:8px;padding:3px;margin-bottom:22px;flex-wrap:wrap}
        .t-btn{flex:1;min-width:50px;padding:7px 4px;border:none;border-radius:6px;cursor:pointer;
          font-family:'Source Sans 3',sans-serif;font-size:11.5px;font-weight:600;
          background:transparent;color:rgba(255,255,255,0.4);transition:all 0.18s;letter-spacing:0.03em}
        .t-btn.on{background:#fff;color:#003087}
        .t-btn:hover:not(.on){color:#fff}
        .grp-label{font-size:10px;font-weight:700;letter-spacing:0.13em;text-transform:uppercase;
          color:rgba(255,255,255,0.35);margin:18px 0 10px;padding-bottom:7px;border-bottom:1px solid rgba(255,255,255,0.08)}
        .fld{margin-bottom:12px}
        .fld label{display:block;font-size:11.5px;font-weight:600;color:rgba(255,255,255,0.6);margin-bottom:5px}
        .fld input,.fld select,.fld textarea{width:100%;background:rgba(255,255,255,0.07);
          border:1px solid rgba(255,255,255,0.12);border-radius:7px;padding:10px 13px;color:#fff;
          font-size:13px;font-family:'Source Sans 3',sans-serif;outline:none;transition:all 0.18s}
        .fld input,.fld select{height:44px}
        .fld textarea{min-height:80px;resize:vertical;line-height:1.6}
        .fld input::placeholder,.fld textarea::placeholder{color:rgba(255,255,255,0.2)}
        .fld input:focus,.fld select:focus,.fld textarea:focus{border-color:rgba(255,255,255,0.5);background:rgba(255,255,255,0.12)}
        .fld select option{background:#003087}
        .g2{display:grid;grid-template-columns:1fr 1fr;gap:10px}
        .tc-box{background:rgba(255,255,255,0.06);border-radius:8px;padding:12px 14px;
          font-size:12px;color:rgba(255,255,255,0.55);line-height:1.6;margin-top:8px}
        .tc-box strong{color:rgba(255,255,255,0.8)}
        .gen-btn{width:100%;height:50px;border:none;border-radius:8px;margin-top:18px;
          background:#fff;color:#003087;font-family:'Source Sans 3',sans-serif;
          font-size:14px;font-weight:700;cursor:pointer;letter-spacing:0.03em;
          transition:all 0.18s;box-shadow:0 6px 20px rgba(0,0,0,0.2)}
        .gen-btn:hover{background:#e8edf5;transform:translateY(-1px)}
        .tab-pane{display:none}.tab-pane.on{display:block}

        /* preview area */
        .preview-area{background:#fff;border-radius:12px;box-shadow:0 8px 40px rgba(0,0,0,0.12);overflow:hidden}

        /* the letter */
        .the-letter{font-family:'Source Sans 3',sans-serif;background:#fff}
        .lh-wrap{padding:28px 48px 0}
        .lh-top{display:flex;justify-content:space-between;align-items:flex-start;padding-bottom:16px}
        .logo-box{display:flex;align-items:center;gap:14px;margin-bottom:8px}
        .logo-sq{width:50px;height:50px;background:#003087;display:flex;align-items:center;justify-content:center;
          font-family:'EB Garamond',serif;font-size:24px;font-weight:700;color:#fff;border-radius:3px}
        .co-name-lh{font-family:'EB Garamond',serif;font-size:21px;font-weight:700;color:#003087;line-height:1.2}
        .co-tagline-lh{font-size:11px;color:#777;letter-spacing:0.06em;margin-top:3px}
        .lh-contact{font-size:12px;color:#555;line-height:1.95;margin-top:10px}
        .ref-block{text-align:right;font-size:12px;color:#555;line-height:1.95;padding-top:4px}
        .ref-no{font-size:13px;font-weight:700;color:#111;display:block;margin-bottom:2px}
        .rule-double{height:3px;background:#003087;margin:0 48px 2px}
        .rule-thin{height:1px;background:#003087;margin:0 48px 12px}
        .letter-body-inner{padding:24px 48px 40px}
        .cand-addr{margin-bottom:18px;font-size:13.5px;line-height:1.8;color:#111}
        .subject-block{margin-bottom:20px}
        .sub-label{font-size:13.5px;font-weight:700;color:#111;margin-bottom:3px}
        .sub-line{font-size:13.5px;font-weight:700;color:#111;text-decoration:underline;line-height:1.5}
        .dear-line{font-size:13.5px;margin-bottom:16px;margin-top:4px}
        .para{font-size:13.5px;line-height:1.85;color:#111;margin-bottom:14px}
        .info-tbl{width:100%;border-collapse:collapse;margin:16px 0 20px}
        .info-tbl td{padding:8px 12px;font-size:13px;border:1px solid #ccc;vertical-align:top}
        .info-tbl td.lbl{font-weight:600;background:#f2f5fb;width:38%;color:#003087}
        .sal-wrap{margin:16px 0 20px}
        .sal-tbl{width:100%;border-collapse:collapse}
        .sal-tbl th{background:#003087;color:#fff;padding:10px 14px;text-align:left;font-size:12.5px;font-weight:600}
        .sal-tbl th:last-child,.sal-tbl td:last-child{text-align:right}
        .sal-tbl td{border:1px solid #dde;padding:9px 14px;font-size:13px}
        .sal-tbl tr:nth-child(even) td{background:#f6f8fc}
        .sal-tbl tfoot td{background:#e4eaf5;font-weight:700;font-size:13.5px;border-top:2px solid #003087}
        .sal-note{font-size:11.5px;color:#666;margin-top:6px;font-style:italic}
        .clauses-title{font-size:12px;font-weight:700;color:#003087;margin:22px 0 12px;text-transform:uppercase;letter-spacing:0.06em}
        .clause-row{display:flex;gap:10px;margin-bottom:10px;font-size:13.5px;line-height:1.85;color:#111}
        .cn{font-weight:700;flex-shrink:0;min-width:24px;color:#003087}
        .sig-section{margin-top:44px;display:flex;justify-content:space-between}
        .sig-box{width:42%}
        .sig-line{border-top:1px solid #333;margin-bottom:9px}
        .sig-name-txt{font-weight:700;font-size:13.5px;color:#111}
        .sig-role-txt{font-size:12.5px;color:#555;line-height:1.7}
        .ack-box{margin:28px 0 0;border:1px solid #bbb;padding:18px 20px;background:#fafafa;border-radius:3px}
        .ack-title{font-weight:700;font-size:13px;text-decoration:underline;margin-bottom:10px;color:#111}
        .ack-row{display:flex;justify-content:space-between;gap:32px;margin-top:18px}
        .ack-sig{flex:1}
        .ack-sig-line{border-top:1px solid #888;margin-bottom:7px}
        .ack-sig-lbl{font-size:12px;color:#555}
        .letter-footer-bar{border-top:1px solid #ccc;padding:12px 48px;font-size:11px;color:#777;line-height:1.75}
        .cin-line{font-weight:600;color:#555}
        .action-bar{background:#f5f7fa;border-top:1px solid #e0e4ed;padding:16px 32px;display:flex;justify-content:flex-end;gap:12px;align-items:center}
        .dl-btn{height:44px;padding:0 24px;background:#003087;color:#fff;border:none;border-radius:7px;
          font-family:'Source Sans 3',sans-serif;font-size:13.5px;font-weight:600;cursor:pointer;transition:all 0.18s}
        .dl-btn:hover{background:#00246b;transform:translateY(-1px)}
        .dl-btn-sec{background:#fff;color:#003087;border:1.5px solid #003087}
        .dl-btn-sec:hover{background:#f0f4ff}
        .empty-state{min-height:660px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:18px;text-align:center;padding:48px}
        .empty-doc{width:100px;height:130px;border:2px solid #dde;border-radius:3px;display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;background:#fafafa}
        .empty-doc::before{content:'';position:absolute;top:-1px;right:-1px;border-left:18px solid transparent;border-bottom:18px solid #dde;border-top:18px solid #fff;border-right:18px solid #fff}
        .empty-lines{margin-top:8px;display:flex;flex-direction:column;gap:6px;width:60px}
        .e-line{height:3px;background:#dde;border-radius:2px}
        .e-line.short{width:70%}
        .empty-title{font-family:'EB Garamond',serif;font-size:24px;color:#bbb;font-weight:700}
        .empty-sub{font-size:13px;color:#bbb;max-width:260px;line-height:1.7}
        .steps{display:flex;gap:6px;align-items:center;font-size:12px;color:#bbb;margin-top:4px}
        .step{padding:4px 12px;border:1px solid #dde;border-radius:20px}
        .arrow-txt{color:#ccc}

        @media(max-width:1100px){.wrap{grid-template-columns:1fr}.sidebar{position:relative;top:0;max-height:none}}
        @media(max-width:680px){
          .lh-wrap,.letter-body-inner,.letter-footer-bar{padding-left:22px;padding-right:22px}
          .rule-double,.rule-thin{margin-left:22px;margin-right:22px}
          .lh-top{flex-direction:column;gap:14px}.ref-block{text-align:left}
          .sig-section{flex-direction:column;gap:28px}.sig-box{width:100%}
          .g2{grid-template-columns:1fr}}
      `}</style>

      <div className="app">
        <div className="wrap">

          {/* ─── SIDEBAR ─── */}
          <div className="sidebar">
            <div className="sb-brand">
              <div className="sb-logo">G</div>
              <div>
                <div className="sb-brand-name">Gurukrupa</div>
                <div className="sb-brand-sub">Offer Letter Studio</div>
              </div>
            </div>
            <div className="sb-title">Letter<br />Generator</div>
            <div className="sb-desc">Compose a professional offer letter in the format used by TCS, Infosys, Wipro and other leading corporates.</div>

            <div className="tab-row">
              {tabs.map(t => (
                <button key={t} className={`t-btn ${tab === t ? "on" : ""}`} onClick={() => setTab(t)}>
                  {tabLabel[t]}
                </button>
              ))}
            </div>

            {/* Company */}
            <div className={`tab-pane ${tab === "company" ? "on" : ""}`}>
              <div className="grp-label">Company Information</div>
              <div className="fld"><label>Company Full Name</label><input name="companyName" value={form.companyName} onChange={set} /></div>
              <div className="fld"><label>Short Name / Abbreviation</label><input name="companyShort" value={form.companyShort} onChange={set} /></div>
              <div className="fld"><label>Tagline</label><input name="companyTagline" value={form.companyTagline} onChange={set} /></div>
              <div className="g2">
                <div className="fld"><label>CIN Number</label><input name="cin" value={form.cin} onChange={set} /></div>
                <div className="fld"><label>Phone</label><input name="companyPhone" value={form.companyPhone} onChange={set} /></div>
              </div>
              <div className="fld"><label>Corporate Address</label><input name="corpAddress" value={form.corpAddress} onChange={set} /></div>
              <div className="fld"><label>Registered Address</label><input name="regAddress" value={form.regAddress} onChange={set} /></div>
              <div className="g2">
                <div className="fld"><label>Email</label><input name="companyEmail" value={form.companyEmail} onChange={set} /></div>
                <div className="fld"><label>Website</label><input name="companyWebsite" value={form.companyWebsite} onChange={set} /></div>
              </div>
              <div className="grp-label">Authorised Signatory</div>
              <div className="g2">
                <div className="fld"><label>Name</label><input name="sigName" value={form.sigName} onChange={set} /></div>
                <div className="fld"><label>Designation</label><input name="sigDesignation" value={form.sigDesignation} onChange={set} /></div>
              </div>
            </div>

            {/* Employee */}
            <div className={`tab-pane ${tab === "employee" ? "on" : ""}`}>
              <div className="grp-label">Candidate Details</div>
              <div className="fld"><label>Full Name</label><input name="employeeName" placeholder="As per Aadhaar / PAN" value={form.employeeName} onChange={set} /></div>
              <div className="fld"><label>Residential Address</label><textarea name="address" placeholder="Full address" value={form.address} onChange={set} style={{ minHeight: 64 }} /></div>
              <div className="g2">
                <div className="fld"><label>Personal Email</label><input name="email" placeholder="candidate@email.com" value={form.email} onChange={set} /></div>
                <div className="fld"><label>Mobile</label><input name="phone" placeholder="+91 XXXXX XXXXX" value={form.phone} onChange={set} /></div>
              </div>
              <div className="g2">
                <div className="fld"><label>Position / Designation</label><input name="position" placeholder="e.g. Software Engineer" value={form.position} onChange={set} /></div>
                <div className="fld"><label>Department</label><input name="department" placeholder="e.g. Technology" value={form.department} onChange={set} /></div>
              </div>
              <div className="g2">
                <div className="fld"><label>Grade / Band</label><input name="grade" placeholder="e.g. L2" value={form.grade} onChange={set} /></div>
                <div className="fld"><label>Employee ID</label><input name="employeeId" placeholder="EMP-001" value={form.employeeId} onChange={set} /></div>
              </div>
              <div className="fld"><label>Reporting Manager</label><input name="manager" placeholder="Manager Name & Designation" value={form.manager} onChange={set} /></div>
            </div>

            {/* Employment */}
            <div className={`tab-pane ${tab === "employment" ? "on" : ""}`}>
              <div className="grp-label">Employment Details</div>
              <div className="g2">
                <div className="fld"><label>Employment Type</label>
                  <select name="employmentType" value={form.employmentType} onChange={set}>
                    <option>Full Time</option><option>Contract</option><option>Internship</option>
                  </select>
                </div>
                <div className="fld"><label>Date of Joining</label><input type="date" name="joiningDate" value={form.joiningDate} onChange={set} /></div>
              </div>
              <div className="g2">
                <div className="fld"><label>Duration / Tenure</label><input name="duration" placeholder="Permanent / 12 Months" value={form.duration} onChange={set} /></div>
                <div className="fld"><label>Probation Period</label><input name="probation" placeholder="6 months" value={form.probation} onChange={set} /></div>
              </div>
              <div className="g2">
                <div className="fld"><label>Place of Posting</label><input name="location" placeholder="Mumbai" value={form.location} onChange={set} /></div>
                <div className="fld"><label>Working Hours</label><input name="workingHours" placeholder="9 AM – 6 PM" value={form.workingHours} onChange={set} /></div>
              </div>
              <div className="g2">
                <div className="fld"><label>Weekly Off</label><input name="weeklyOff" value={form.weeklyOff} onChange={set} /></div>
                <div className="fld"><label>Notice Period</label><input name="noticePeriod" value={form.noticePeriod} onChange={set} /></div>
              </div>
              <div className="fld"><label>Leave Policy</label><input name="leavePolicy" value={form.leavePolicy} onChange={set} /></div>
              <div className="fld"><label>Job Responsibilities</label><textarea name="workDescription" placeholder="Describe key duties and deliverables..." value={form.workDescription} onChange={set} /></div>
              {isIntern && <>
                <div className="grp-label">Internship Details</div>
                <div className="g2">
                  <div className="fld"><label>Internship Type</label>
                    <select name="internshipType" value={form.internshipType} onChange={set}>
                      <option value="">Select</option><option>Paid</option><option>Unpaid</option>
                    </select>
                  </div>
                  {form.internshipType === "Paid" && <div className="fld"><label>Monthly Stipend (₹)</label><input type="number" name="stipend" value={form.stipend} onChange={set} /></div>}
                </div>
              </>}
            </div>

            {/* Compensation */}
            <div className={`tab-pane ${tab === "compensation" ? "on" : ""}`}>
              {hasSalary ? <>
                <div className="grp-label">CTC Breakup (Monthly ₹)</div>
                <div className="g2">
                  <div className="fld"><label>Basic Salary</label><input type="number" name="salary" value={form.salary} onChange={set} /></div>
                  <div className="fld"><label>HRA</label><input type="number" name="hra" value={form.hra} onChange={set} /></div>
                </div>
                <div className="g2">
                  <div className="fld"><label>Conveyance Allowance</label><input type="number" name="conveyance" value={form.conveyance} onChange={set} /></div>
                  <div className="fld"><label>Medical Allowance</label><input type="number" name="medicalAllowance" value={form.medicalAllowance} onChange={set} /></div>
                </div>
                <div className="g2">
                  <div className="fld"><label>Performance Bonus</label><input type="number" name="bonus" value={form.bonus} onChange={set} /></div>
                  <div className="fld"><label>Special Allowance</label><input type="number" name="specialAllowance" value={form.specialAllowance} onChange={set} /></div>
                </div>
                {totalCTC > 0 && (
                  <div className="tc-box">
                    Monthly CTC: <strong>₹{fmt(totalCTC)}</strong> &emsp;|&emsp; Annual CTC: <strong>₹{fmt(totalCTC * 12)}</strong>
                  </div>
                )}
              </> : isIntern ? (
                <div className="tc-box" style={{ marginTop: 0 }}>Stipend fields are in the <strong>Job</strong> tab.</div>
              ) : (
                <div style={{ color: "rgba(255,255,255,0.3)", fontSize: 13, textAlign: "center", padding: "28px 0" }}>
                  Set employment type in the <strong style={{ color: "rgba(255,255,255,0.5)" }}>Job</strong> tab first.
                </div>
              )}
            </div>

            {/* Terms */}
            <div className={`tab-pane ${tab === "terms" ? "on" : ""}`}>
              <div className="grp-label">Benefits & Policies</div>
              <div className="fld"><label>Benefits</label><textarea name="benefits" value={form.benefits} onChange={set} /></div>
              <div className="fld"><label>Documents Required at Joining</label><textarea name="documentsRequired" value={form.documentsRequired} onChange={set} style={{ minHeight: 72 }} /></div>
              <div className="fld"><label>Additional Terms & Conditions</label><textarea name="additionalTerms" value={form.additionalTerms} onChange={set} /></div>
            </div>

            <button className="gen-btn" onClick={() => setShow(true)}>Generate Offer Letter →</button>
          </div>

          {/* ─── PREVIEW ─── */}
          <div className="preview-area">
            {show ? (
              <>
                <div id="the-letter" className="the-letter">

                  {/* LETTERHEAD */}
                  <div className="lh-wrap">
                    <div className="lh-top">
                      <div>
                        <div className="logo-box">
                          <div className="logo-sq">{form.companyShort?.[0] || "G"}</div>
                          <div>
                            <div className="co-name-lh">{form.companyName}</div>
                            <div className="co-tagline-lh">{form.companyTagline}</div>
                          </div>
                        </div>
                        <div className="lh-contact">
                          {form.corpAddress}<br />
                          Tel: {form.companyPhone} &nbsp;|&nbsp; {form.companyEmail} &nbsp;|&nbsp; {form.companyWebsite}
                        </div>
                      </div>
                      <div className="ref-block">
                        <span className="ref-no">Ref: {form.employeeId || "HR/OL/2025/001"}</span>
                        Date: {today}
                      </div>
                    </div>
                  </div>
                  <div className="rule-double" />
                  <div className="rule-thin" />

                  {/* BODY */}
                  <div className="letter-body-inner">

                    {/* Candidate address */}
                    {form.employeeName && (
                      <div className="cand-addr">
                        <strong>{form.employeeName}</strong>
                        {form.address && <><br />{form.address}</>}
                        {form.phone && <><br />Mobile: {form.phone}</>}
                        {form.email && <><br />Email: {form.email}</>}
                      </div>
                    )}

                    {/* Subject */}
                    <div className="subject-block">
                      <div className="sub-label">Subject:</div>
                      <div className="sub-line">
                        Offer of {isIntern ? "Internship" : "Employment"} — {form.position || "__________"}, {form.department || "__________"}
                      </div>
                    </div>

                    <div className="dear-line">Dear {form.employeeName ? `${form.employeeName},` : "Candidate,"}</div>

                    <p className="para">
                      We are pleased to offer you the position of <strong>{form.position || "__________"}</strong> in the <strong>{form.department || "__________"}</strong> department at <strong>{form.companyName}</strong>{form.location ? ` (${form.location})` : ""}, effective <strong>{fmtDate(form.joiningDate)}</strong>. This offer is based on our discussions, your candidature assessment, and subject to the terms and conditions set out herein.
                    </p>

                    {/* Details table */}
                    <table className="info-tbl">
                      <tbody>
                        <tr><td className="lbl">Name</td><td>{form.employeeName || "—"}</td></tr>
                        <tr><td className="lbl">Designation</td><td>{form.position || "—"}</td></tr>
                        <tr><td className="lbl">Department</td><td>{form.department || "—"}</td></tr>
                        {form.grade && <tr><td className="lbl">Grade / Band</td><td>{form.grade}</td></tr>}
                        <tr><td className="lbl">Employee ID</td><td>{form.employeeId || "To be allotted on joining"}</td></tr>
                        <tr><td className="lbl">Date of Joining</td><td>{fmtDate(form.joiningDate)}</td></tr>
                        <tr><td className="lbl">Place of Posting</td><td>{form.location || "—"}</td></tr>
                        <tr><td className="lbl">Employment Type</td><td>{form.employmentType || "—"}</td></tr>
                        <tr><td className="lbl">Duration / Tenure</td><td>{form.duration || "—"}</td></tr>
                        <tr><td className="lbl">Reporting To</td><td>{form.manager || "—"}</td></tr>
                        <tr><td className="lbl">Working Hours</td><td>{form.workingHours || "—"}</td></tr>
                        <tr><td className="lbl">Weekly Off</td><td>{form.weeklyOff || "—"}</td></tr>
                        <tr><td className="lbl">Probation Period</td><td>{form.probation || "—"}</td></tr>
                        <tr><td className="lbl">Notice Period</td><td>{form.noticePeriod || "—"}</td></tr>
                      </tbody>
                    </table>

                    {/* Salary table */}
                    {hasSalary && totalCTC > 0 && (
                      <>
                        <p className="para" style={{ marginBottom: 6 }}>Your compensation package will be as follows:</p>
                        <div className="sal-wrap">
                          <table className="sal-tbl">
                            <thead><tr><th>Salary Component</th><th>Monthly (₹)</th><th>Annual (₹)</th></tr></thead>
                            <tbody>
                              {form.salary && <tr><td>Basic Salary</td><td>₹{fmt(form.salary)}</td><td>₹{fmt(form.salary * 12)}</td></tr>}
                              {form.hra && <tr><td>House Rent Allowance (HRA)</td><td>₹{fmt(form.hra)}</td><td>₹{fmt(form.hra * 12)}</td></tr>}
                              {form.conveyance && <tr><td>Conveyance Allowance</td><td>₹{fmt(form.conveyance)}</td><td>₹{fmt(form.conveyance * 12)}</td></tr>}
                              {form.medicalAllowance && <tr><td>Medical Allowance</td><td>₹{fmt(form.medicalAllowance)}</td><td>₹{fmt(form.medicalAllowance * 12)}</td></tr>}
                              {form.bonus && <tr><td>Performance Bonus</td><td>₹{fmt(form.bonus)}</td><td>₹{fmt(form.bonus * 12)}</td></tr>}
                              {form.specialAllowance && <tr><td>Special Allowance</td><td>₹{fmt(form.specialAllowance)}</td><td>₹{fmt(form.specialAllowance * 12)}</td></tr>}
                            </tbody>
                            <tfoot><tr><td>Total Cost to Company (CTC)</td><td>₹{fmt(totalCTC)}</td><td>₹{fmt(totalCTC * 12)}</td></tr></tfoot>
                          </table>
                          <div className="sal-note">* The above figures are gross amounts. Applicable statutory deductions (PF, Professional Tax, TDS) shall be as per prevailing norms.</div>
                        </div>
                      </>
                    )}

                    {/* Internship pay */}
                    {isIntern && form.internshipType && (
                      <p className="para">
                        This is a <strong>{form.internshipType}</strong> internship.{" "}
                        {form.internshipType === "Paid" && form.stipend
                          ? <>A monthly stipend of <strong>₹{fmt(form.stipend)}</strong> shall be paid subject to satisfactory performance and attendance.</>
                          : form.internshipType === "Unpaid"
                          ? "No monetary compensation shall be provided; however, a certificate of internship shall be issued upon successful completion."
                          : ""}
                      </p>
                    )}

                    {form.workDescription && (
                      <p className="para"><strong>Key Responsibilities:</strong> {form.workDescription}</p>
                    )}
                    {form.benefits && (
                      <p className="para"><strong>Benefits & Perquisites:</strong> {form.benefits}</p>
                    )}
                    {form.leavePolicy && (
                      <p className="para"><strong>Leave Entitlement:</strong> {form.leavePolicy}</p>
                    )}

                    {/* Numbered T&C */}
                    <div className="clauses-title">Terms and Conditions</div>
                    {[
                      "Your appointment is subject to your being medically fit, satisfactory reference / background checks, and verification of all original documents submitted.",
                      `During the probation period of <strong>${form.probation || "6 months"}</strong>, your performance and conduct shall be evaluated. Confirmation is subject to satisfactory completion of probation. Either party may terminate the probationary engagement with ${form.noticePeriod || "30 days"} written notice.`,
                      "This offer is strictly confidential and is made to you personally. You are requested not to disclose the terms to any third party.",
                      "You are required to maintain absolute confidentiality regarding all proprietary information, client data, business strategies, and internal processes of the company both during and after employment.",
                      `Any intellectual property created by you in the course of your employment shall be the sole property of ${form.companyName}.`,
                      "You shall not engage in any other employment, consultancy, or business activity that creates a conflict of interest without prior written approval of the management.",
                      "This offer shall lapse if not accepted by you in writing within 7 days of the date of this letter.",
                      form.additionalTerms,
                    ].filter(Boolean).map((text, i) => (
                      <div className="clause-row" key={i}>
                        <span className="cn">{i + 1}.</span>
                        <span dangerouslySetInnerHTML={{ __html: text }} />
                      </div>
                    ))}

                    {form.documentsRequired && (
                      <p className="para" style={{ marginTop: 14 }}>
                        <strong>Documents to be submitted at the time of joining:</strong><br />{form.documentsRequired}
                      </p>
                    )}

                    <p className="para" style={{ marginTop: 16 }}>
                      We look forward to you joining us and are confident that you will find the role professionally rewarding. Please sign and return a copy of this letter as your formal acceptance.
                    </p>

                    {/* Signatures */}
                    <div className="sig-section">
                      <div className="sig-box">
                        <div className="sig-line" />
                        <div className="sig-name-txt">{form.sigName}</div>
                        <div className="sig-role-txt">{form.sigDesignation}<br />{form.companyName}</div>
                      </div>
                      <div className="sig-box" style={{ textAlign: "right" }}>
                        <div className="sig-role-txt" style={{ marginBottom: 8, color: "#aaa" }}>For {form.companyName}</div>
                        <div className="sig-line" />
                        <div className="sig-role-txt">Authorised Signatory</div>
                      </div>
                    </div>

                    {/* Acceptance */}
                    <div className="ack-box">
                      <div className="ack-title">Acceptance of Offer</div>
                      <div style={{ fontSize: 13, color: "#333", lineHeight: 1.8 }}>
                        I, <strong>{form.employeeName || "__________________________"}</strong>, hereby accept the offer of {isIntern ? "internship" : "employment"} extended by <strong>{form.companyName}</strong> on the terms and conditions stated above. I confirm that all information provided by me is true and correct, and I agree to abide by the company's policies and code of conduct.
                      </div>
                      <div className="ack-row">
                        <div className="ack-sig"><div className="ack-sig-line" /><div className="ack-sig-lbl">Signature of Candidate</div></div>
                        <div className="ack-sig"><div className="ack-sig-line" /><div className="ack-sig-lbl">Date of Acceptance</div></div>
                        <div className="ack-sig"><div className="ack-sig-line" /><div className="ack-sig-lbl">Place</div></div>
                      </div>
                    </div>
                  </div>

                  {/* FOOTER */}
                  <div className="letter-footer-bar">
                    <span className="cin-line">CIN: {form.cin}</span><br />
                    Registered Office: {form.regAddress}<br />
                    This is a system-generated offer letter. For queries, contact: {form.companyEmail}
                  </div>
                </div>

                <div className="action-bar">
                  <button className="dl-btn dl-btn-sec" onClick={() => setShow(false)}>← Edit</button>
                  <button className="dl-btn" onClick={printLetter}>Download / Print PDF</button>
                </div>
              </>
            ) : (
              <div className="empty-state">
                <div className="empty-doc">
                  <div className="empty-lines">
                    <div className="e-line" /><div className="e-line short" />
                    <div className="e-line" /><div className="e-line short" />
                    <div className="e-line" />
                  </div>
                </div>
                <div className="empty-title">Preview appears here</div>
                <div className="empty-sub">Fill the form and click Generate Offer Letter to see the document.</div>
                <div className="steps">
                  <div className="step">Fill details</div>
                  <div className="arrow-txt">→</div>
                  <div className="step">Generate</div>
                  <div className="arrow-txt">→</div>
                  <div className="step">Download PDF</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}